module.exports = __webpack_public_path__ + "img/cs.6367e22f.png";